<template lang="pug">
	.track-url-global-exclude
		.track-url-events(v-if="_.size(settingValue) > 0")
			.track-url-event(:class="'event-name-' + _.kebabCase(eventName)" v-for="eventName in settingValue")
				.track-url-event-name
					span.track-url-event-title {{(eventsSettings && eventsSettings[eventName] && eventsSettings[eventName].name) ? eventsSettings[eventName].name : eventName}}
					.track-url-event-remove(@click="removeEvent(eventName)")
						i.fa.fa-times
		.add-new-event
			select.custom-select.custom-select-sm(v-on:change="addNewEvent($event.target)")
				option(:selected="true" value="none") Add new event
				option(v-for="event in events" v-if="!settingValue[event.name]" :selected="false" :value="event.name") {{event.title || event.name}}
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Project } 			from './../../../services/Project';
	import { Settings } 		from './../../../services/Settings';
	import { Version } 			from './../../../services/Version';

	export default {
		name: "TrackUrlGlobalExclude",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Selected Version Settings Loaded", "Selected Version Settings Original Loaded"]
		},
		props: ['setting'],
		data() {

			this.Project = Project;
			this.Settings = Settings;

			this.events = [];
			this.settingValue = {};

			return {
				showed: true
			}

		},
		mounted() {

			// Сообщаем компоненту что он должен обновляться при изменении указанных настроек активной версии проекта
			this.addUpdateEvent([`Selected Version Setting Changed:track-url-global-exclude`, `Selected Version Setting Changed:track-events`, `Selected Version Setting Changed:track-events-settings`]);

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('TrackUrlGlobalExclude collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.events = Settings.getTrackingEvents();
				this.settingValue = Settings.getSettingValue(this.setting.codename) || [];
				this.eventsSettings = Settings.getSettingValue('track-events-settings');

			},
			addNewEvent(el) {

				if (el.value === "none") return;

				if (this.settingValue.indexOf(el.value) > -1) return;

				this.settingValue.push(el.value);

				console.log(el.value);

				this.$forceUpdate();

				el.value = 'none';

				this.delaySave();

			},
			removeEvent(eventName) {

				this.settingValue.splice(this.settingValue.indexOf(eventName),1);

				this.$forceUpdate();

				this.delaySave();

			},
			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Server.sendToSocket({
						UpdateProjectVersionSetting: {
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							value: this.settingValue
						}
					});

					console.log(this.settingValue);

				}, 200);

			}
		}
	}
</script>

<style lang="sass">

	.track-url-global-exclude
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74

		.track-url-events
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.track-url-event
				display: flex
				flex-direction: column
				position: relative
				user-select: none

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.track-url-event-name
					display: flex
					flex-direction: row
					justify-content: space-between
					padding: 0 5px 0px 5px

					.track-url-event-title
						user-select: none
						margin: auto 0

					.track-url-event-remove
						cursor: pointer
						transition: 0.2s
						padding: 4px 7px
						font-size: 14px
						color: #fff

						&:hover
							color: #20a8d8

						.fa-times
							padding-top: 0

</style>
